import { Button } from "@circleco/compass/components/Button";
import { Typography } from "@circleco/compass/components/Typography";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";

import { ListWrapper } from "./ListWrapper";

export const NoMessages = () => {
  const navigate = useNavigate();

  return (
    <ListWrapper className="flex flex-col items-center justify-center !space-y-4">
      <div className="flex flex-col items-center justify-center gap-2">
        <Typography variant="heading-md">
          {t("messaging.no_messages")}
        </Typography>
        <Typography variant="body-md" color="secondary">
          {t("header_v3.send_new_dm_description")}
        </Typography>
      </div>
      <Button
        variant="primary"
        onClick={() => {
          void navigate({ to: "/messages/$uuid", params: { uuid: "new" } });
        }}
      >
        {t("header_v3.send_new_dm")}
      </Button>
    </ListWrapper>
  );
};
